<template>
  <div :id="'row-' + product.id" class="mtrx-row"  @click="toggleDetails()" :class="{ 'is-selected': activeProduct === product.id }">
    <div class="prod-code">
      <span class="value">{{ product.id }}</span>
    </div>
    
    <template v-if="screenWidth > 768">      
      <div class="prod-spec" :class="{ 'double-col': containsLongValue(prodSpecDesc)}" v-for="prodSpecDesc in categorySpecifications" :key="prodSpecDesc">
        {{ product.properties[prodSpecDesc] }}
      </div>    
    </template>

    <div class="prod-stock" v-if="showStock">
      <template v-if="product.customBooleans.HAS_CUSTOM_STOCK_TXT">
        <span class="key" v-translation="{ code: 'label_price_on_req', type: 'label' }"></span>
      </template>
      <template v-else>
        <utlz-product-stock
            :stock="product.stock"
            :stockTotal="product.stock"
          ></utlz-product-stock>
      </template>
    </div>

    <template v-if="!product.customBooleans.PRICE_ON_REQUEST">
      <div v-if="product.prices.length" class="prod-price">
        <utlz-product-price
          :prices="product.prices[0]"
          :parentClassRef="'ref-product-list-item'"
        ></utlz-product-price>
      </div>
    </template>
    <div @click.stop :class="{'por': product.customBooleans.PRICE_ON_REQUEST }" class="prod-order" v-if="showOrderProductControl">
      

      <template v-if="product.customBooleans.PRICE_ON_REQUEST">
        <utlz-price-onrequest :productDescription="product.shortDescription" :productId="product.id"></utlz-price-onrequest>
      </template>

      <template v-else>
        <template v-if="product.prices.length">
          <utlz-order-product
            :product="computedProduct"
            :parentClassRef="'ref-product-list-item'"
          >
          </utlz-order-product>
        </template>
      </template>

    </div>
    <template v-if="activeProduct === product.id || screenWidth < 767">
      <div class="active-product container-fluid">
        <div class="row active-row">
          <div class="img-main col-sm-4">
            <div>

              <template v-if="product.imageUrl">
                <utlz-gallery :singleImage="true" :product="product"></utlz-gallery>
              </template>

            </div>
          </div>
            <div class="img-sec col-sm-4">
              <template v-if="product.images.length > 1">
                <utlz-gallery :skipMainImage="true" :product="product"></utlz-gallery>
              </template>
            </div>
          <div class="specs col-sm-4">
            <ul class="specs-sel" @click.stop>              
              <li v-for="prodSpecDesc in matrixDetailsSpecifications" :key="prodSpecDesc">
                <span class="key">
                  {{ prodSpecDesc }}
                </span>
                <span class="val">
                  {{ product.properties[prodSpecDesc] }}
                </span>
              </li>
              <template v-if="productDocuments.length">
                <li>
                  <span class="key" v-translation="{ code: 'label_mtrx_downloads', type: 'label' }">
                  </span>
                  <div class="val docs">                    
                    <a target="_blank"
                      v-for="(prodDoc, index) in productDocuments" 
                      :key="index"
                      :href="prodDoc.fileLocation" class="pill lb">
                      {{ getFileExtension(prodDoc.description) }}
                      </a>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { Product } from 'src/models/product.model';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import Gallery from 'src/components/ui/gallery/Gallery.vue';
import PriceOnRequest from './../../price-on-request/PriceOnRequest.vue';

export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-product-stock': ProductStock,
    'utlz-order-product': OrderProduct,
    'utlz-gallery': Gallery,
    'utlz-price-onrequest': PriceOnRequest
  },
  props: {
    product: { type: Product, required: true },
    blockSize: { type: Number, required: false, default: 3 },
    activeProductId: { type: String, required: false, default: "" }
  },
  data () {
    return {
      isSalesAction: this.product.prices[0],
      activeProductVariantId: null
    };
  },
  computed: {
    ...mapGetters(['screenWidth']),
    ...mapGetters('elastic', ['categorySpecifications', 'matrixDetailsSpecifications', 'activeProduct', 'productDocuments']),
    ...mapGetters(['showStock', 'showPrices', 'showFavorites', 'showOrderProduct', 'stockLimit', 'groupProductsList', 'screenWidth']),
    showOrderProductControl () {
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.product.stock !== null) {
          return this.stockLimit && this.product.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showOutOfStockMessage () {
      if (!this.stockLimit) {
        return false;
      } else if (this.product.stock !== null && this.showOrderProduct) {
        return this.product.stock.stockTotal <= 0;
      } else {
        return false;
      }
    },
    computedProduct () {
      if (!this.product.variantKey) {
        return this.product;
      } else {
        if (this.activeProductVariantId) {
          const index = this.product.productVariants.findIndex(product => {
            return product.id === this.activeProductVariantId;
          });
          return this.product.productVariants[index];
        } else {
          return this.product;
        }
      }
    },
    productImageBanners () {
      return this.product.productImageBanners.filter(banner => banner.show === true);
    }
  },
  methods: {
    ...mapActions('elastic', ['setActiveProduct']),
    containsLongValue(value) {
      var value = value.toLowerCase();
      return value == 'afmeting' || 
      value == 'dimensions' ||
      value == 'abmessungen';
    },
    selectedProduct (id) {
      this.activeProductVariantId = id;
    },
    toggleDetails() {
      this.setActiveProduct(this.product.id);
    },
    getFileExtension(uri) {
      // Extract the file name from the URI
      const fileName = uri.split('/').pop();
      // Extract the extension without the dot
      const extension = fileName.split('.').pop();
      return extension;
    }
  }
};
</script>

<style>
</style>
